import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetMyPropertyViewsDailyQuery } from 'src/redux/api'

interface IViewsSparkline {
  propertyId: string
}

// Tiny dependency-free SVG sparkline: views per day over the last two weeks
// (roadmap 28.4). Hidden entirely while the listing has no views yet.
const ViewsSparkline: FC<IViewsSparkline> = ({ propertyId }) => {
  const { t } = useTranslation()
  const { data } = useGetMyPropertyViewsDailyQuery({ id: propertyId })

  const days = data?.days || []
  const max = Math.max(...days.map((day) => day.count), 0)
  if (days.length === 0 || max === 0) return null

  const width = 120
  const height = 24
  const step = width / (days.length - 1 || 1)
  const points = days
    .map((day, index) => {
      const x = index * step
      const y = height - (day.count / max) * (height - 2) - 1
      return `${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')

  return (
    <div
      className="flex items-center justify-center gap-2 px-2 pb-1"
      title={t('my_offers.views_14d')}
    >
      <svg width={width} height={height} className="text-brand">
        <polyline
          points={points}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default ViewsSparkline
